import type { BankDetails, Profile } from '@entities/agent-contract';

export const getBankDetails = (
  bankDetails?: Profile['bankDetails']
): Partial<BankDetails> => {
  const { bic, nameBank, corAccount, bankAccount } = bankDetails || {};

  return {
    bic,
    nameBank,
    corAccount,
    bankAccount,
  };
};
